module.exports = __webpack_public_path__ + "static/boop-1c0ddf78684ecee8e96470d50665a745.jpg";